module.exports = __webpack_public_path__ + "p6_img1.png?fa4512d0da6438ab81f17d7aa9c3fc15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img1.png
// module id = 58
// module chunks = 0